module.exports = __webpack_public_path__ + "202408221624/img/img_example_draft_120@2x.77e53cf7.png";